import { gql } from '@apollo/client';

export const CORE_PLAYLIST_FIELDS = gql`
  fragment CorePlaylistFields on Playlist {
    id
    shortId
    publishedAt
    status
    shareType
    name {
      languageCode
      value
    }
    description {
      languageCode
      value
    }
    courses {
      thumbnail {
        file {
          key
        }
      }
      id
      name {
        languageCode
        value
      }
    }
    ownerId
    lastReminderAt
  }
`;
